import { Modal, createStyles } from '@mantine/core';

import { Drawer } from '~/domains/design-system/components/Drawer/Drawer';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import ConfirmationDrawer from './ConfirmationDrawer';
import dt from '~/testing';

const useClasses = createStyles((theme) => ({
  overlay: {
    zIndex: theme.other.zIndex.referAFriendDrawer,
  },
  content: {
    zIndex: theme.other.zIndex.referAFriendDrawer + 1,
    maxWidth: '420px',
  },
  close: {
    display: 'none',
  },
}));

type ConfirmationModalProps = {
  onCancel?: () => void;
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
};

export default function ConfirmationModal({
  isOpen,
  onCancel,
  onClose,
  onConfirm,
}: ConfirmationModalProps) {
  const isMobile = useIsMobile();
  const { classes } = useClasses();
  return isMobile ? (
    <Drawer onClose={onClose} open={isOpen} classes={classes}>
      <ConfirmationDrawer onClose={onClose} onConfirm={onConfirm} onCancel={onCancel} />
    </Drawer>
  ) : (
    <Modal
      data-test-id={dt.components.shared.auth.signUpVersionTwo.confirmationModal.confirmationModal}
      opened={isOpen}
      onClose={onClose}
      centered
      withCloseButton={false}
      size="420px"
      /* eslint-disable-line local-rules/use-theme-tokens */ radius={24}
      padding={0}
      overlayColor="rgba(0, 0, 0, 0.60)"
    >
      <ConfirmationDrawer onClose={onClose} onConfirm={onConfirm} onCancel={onCancel} />
    </Modal>
  );
}
